import { Option } from 'funfix-core';
import React from 'react';
import { ANALYTICS_MODAL_INSTRUCTIONAL } from '../../../../analytics/Sources';
import ExternalMarketplaceLink from '../common/ExternalMarketplaceLink';
import DialogInstructionalContent from './DialogInstructionalContent';
import DialogInstructionalFooter from './DialogInstructionalFooter';
const resolveDialogInstructional = _ref => {
  let {
    closeInstallDialog,
    instructionalInstallMode,
    links,
    appDetailsFromSearchResponse,
    onRendered
  } = _ref;
  return {
    analyticsSourceModal: ANALYTICS_MODAL_INSTRUCTIONAL,
    content: /*#__PURE__*/React.createElement(DialogInstructionalContent, {
      appDetailsFromSearchResponse: appDetailsFromSearchResponse,
      instructionalApp: instructionalInstallMode.instructionalApp,
      links: links,
      onRendered: onRendered
    }),
    heading: 'Installation instructions',
    footerLeft: /*#__PURE__*/React.createElement(ExternalMarketplaceLink, {
      marketplaceAppDetails: instructionalInstallMode.instructionalApp.details,
      links: links
    }),
    footerRight: /*#__PURE__*/React.createElement(DialogInstructionalFooter, {
      closeInstallDialog: closeInstallDialog,
      instructionalApp: instructionalInstallMode.instructionalApp
    }),
    preventDialogClosing: false,
    errorDetails: Option.empty()
  };
};
export default resolveDialogInstructional;